import { loginEmail } from "@ueni/users-api";
import { AxiosError } from "axios";
import { useCallback, useState } from "react";
import { useParams } from "react-router";
import { eventsV2 } from "../../../constants/eventsV2";
import { useQuery } from "../../../hooks";
import { useErrorHandling } from "../../../hooks/useErrorHandling";
import { loginEmailSchema as validationSchema } from "../../../schema";
import api from "../../../services/api";
import { sendEvent } from "../../../utils/analytics/sendEvent";

export const useLoginEmailPage = () => {
  const { handleApiError } = useErrorHandling();
  const params = useParams();
  const [showSend, setShowSend] = useState(false);
  const locale = params["locale"];
  const query = useQuery();
  const redirect_url = query.get("redirect_url");

  const initialValues = {
    email: "",
    redirect_url,
  };

  const onFocus = useCallback(() => {
    setShowSend(false);
  }, [setShowSend]);

  const onSubmit = useCallback(
    async (data, actions) => {
      sendEvent(eventsV2.login.emailLogin({ label: locale }));
      try {
        await loginEmail(api, data);
        actions.resetForm();
        setShowSend(true);
      } catch (e) {
        handleApiError(e as AxiosError, actions);
      }
    },
    [locale, setShowSend]
  );

  return {
    initialValues,
    validationSchema,
    onSubmit,
    locale,
    showSend,
    onFocus,
  };
};
